import { useEffect, useState } from "react";
import { getSubCateLinks } from "../../utils/requests/subcate";
import { usePathname } from "next/navigation";
import Link from "next/link";

import {
  Box,
  Typography,
  Stack,
} from "@mui/material";

export type SubcateLinksDetailProps = {
  t: any;
  locale: string;
  actionid: string;
  categoryid: string;
  searchParamsList: any;
};

export const SubcateLinksDetail = ({
  t,
  locale,
  actionid,
  categoryid,
  searchParamsList,
}: SubcateLinksDetailProps) => {
  const pathname = usePathname();

  const [subcates, setSubCates] = useState<Record<string, any[]>>({});

  useEffect(() => {
    const load = async () => {
      const {
        province,
        amphur,
        locationid,
        locationtypeid,
        locationbranchid,
      } = searchParamsList;

      const links = await getSubCateLinks(
        locale,
        actionid || "1",
        categoryid,
        province,
        amphur,
        locationtypeid,
        locationbranchid
      );
      links?.data && setSubCates(links.data);
    };

    load();
  }, [searchParamsList]);

  const genSubcate = (items: any[]) => {
    if (!items || !pathname) return null;

    let onlySeoUrl = decodeURIComponent(pathname);
    const pathSegments = onlySeoUrl.split("/").filter(Boolean);
    const projectIdIndex = pathSegments.findIndex((seg) => /^\d+$/.test(seg));
    const basePathSegments =
      projectIdIndex !== -1
        ? pathSegments.slice(0, projectIdIndex)
        : pathSegments;
    onlySeoUrl = "/" + basePathSegments.join("/");

    const domainUrl =
      typeof window !== "undefined"
        ? window.location.origin.replace(/\/$/, "")
        : "";

    return (
      <Stack sx={{ lineHeight: '100%'}}>
        {items.map((item) => {
          const subcatefilter = item.url;
          const subcateUrl = `${domainUrl}${onlySeoUrl}/${subcatefilter.groupcate}/${subcatefilter.subcate}`;

          return (
            <Link key={item.name} href={subcateUrl} passHref>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "12px",
                  color: "text.secondary",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {item.name}
              </Typography>
            </Link>
          );
        })}
      </Stack>
    );
  };

  if (!subcates || Object.keys(subcates).length === 0) return null;

  return (
    <Box bgcolor="#fff" p={2} borderRadius="10px">
      {Object.keys(subcates).map((key) => (
        <Box key={key} mb={2}>
          <Typography
            variant="h4"
            fontWeight="bold"
            color="text.primary"
            fontSize={14}
          >
            {key}
          </Typography>
          {genSubcate(subcates[key])}
        </Box>
      ))}
    </Box>
  );
};
